import { setApp } from '@/utils/app'
import { BuilderGptMutations } from './types'
const mutations:BuilderGptMutations = {
    changeStep(state, value: number) {
        state.currentStep = value
    },
    confirmStep(state) {
        if(!state.confirmedSteps.includes(state.currentStep)) {
            state.confirmedSteps.push(state.currentStep)
        }
        if(state.currentStep >= state.accessibleStep) {
            state.accessibleStep = state.currentStep + 1 
        }
    },
    setData(state, data){
        state.app = {...state.app, ...data}
    },
    setAppColor(state, data:any) {
        state.app.primaryColor = data.primaryColor
    },
    setAppName(state, data:any) {
        state.app.name = data.name
    },
    setAppCurrency(state, data:any) {
        state.app.currency = data.currency
    },
    setAppEmail(state, data:any) {
        state.app.email = data.email
    },
    setAppTelegram(state, data:any) {
        state.app.telegram = data.telegram
    },
    setAppId(state, data:any) {
        state.app.id = data.id
    },
    setTariffs(state, data:any) {
        state.app.tariffs = data.tariffs
    },
    setPromotionalPage(state, data:any) {
        state.app.promotionalPage= data.promotionalPage
    },
    setAppBotLimits(state, data:any) {
        state.app.botLimit = data.botLimit
        state.app.botLimitType = data.botLimitType
    },
    setAppEmptyChatLogo(state, data:any) {
        state.app.emptyChatLogo = data.emptyChatLogo
    },
    setAppAvatarBlob(state, data:any) {
        state.app.avatarBlob = data.avatarBlob
    },

    setAppEmptyChatMessage(state, data:any) {
        state.app.emptyChatMessage = data.emptyChatMessage
    },
    setApp(state, data:any) {
        state.app = {...state.app, ...data}
    },
    saveToLocalStorage(state) {
        const data = state
        localStorage.setItem('gpt_builder', JSON.stringify(data))
    },
    clearLocalStorage() {
        localStorage.removeItem('gpt_builder')
    },
    updateStateByLocalStorage(state, data) {
        state.currentStep = data.currentStep
        state.accessibleStep = data.accessibleStep
        state.confirmedSteps = data.confirmedSteps
        // TODO рассписать по отдельности нужные поля.
        state.app = {...state.app, ...data.app}
    },
    setTariffId(state, data) {
        state.app.tariffs[data.index].id = data.id
    },
    setPromotionalPageId(state, data) {
        state.app.promotionalPage.id = data.id
    }
}
export default mutations